const USER_TIP = {
  '2': {
    keyword: '商家名/酒店/色系/风格/赠送内容/营销词等，建议12-24个字，如下',
    ex: [
      '50-80人小型婚礼之选 静谧蓝婚礼送首席四大',
      '【XX婚礼】16年大热 镜面T台水晶布景超炫灯光',
      '福朋喜来登酒店•刘诗诗同款 花艺设计效果满分'
    ],
    long: '440px'
  },
  '6': {
    keyword: `建议输入营销点（立减1000、机票补贴、轻旅拍...直接体现价格优惠）、风格（纪实、清新、中式、森系）、场景（海景、游艇、水下、教堂）、商家简称（xx婚纱摄影旗舰店...）、
      优惠信息（拍一送一、底片全送、团队升级...）、服装套系（十服十造等等）、精修（精修50张等等）等信息；`,
    ex: [
      '韩式公主风+双内景+精修50张',
      '【小清新】文艺青年喜爱的电影剧情风格 外景+内景 精修140张',
      '丽江雪山拉市海骑马划船浪漫旅拍'
    ],
    long: '582px',
    children: [
      {
        id: 1,
        keyword: `建议输入营销点（立减1000、机票补贴、轻旅拍...直接体现价格优惠）、风格（纪实、清新、中式、森系）、场景（海景、游艇、水下、教堂）、商家简称（xx婚纱摄影旗舰店...）、
        优惠信息（拍一送一、底片全送、团队升级...）、服装套系（十服十造等等）、精修（精修50张等等）等信息；`,
        ex: [
          '韩式公主风+双内景+精修50张',
          '【小清新】文艺青年喜爱的电影剧情风格 外景+内景 精修140张',
          '丽江雪山拉市海骑马划船浪漫旅拍'
        ]
      },
      {
        id: 6,
        keyword: `建议输入城市、营销点（立减1000、机票补贴、轻旅拍...直接体现价格优惠）、风格（纪实、清新、中式、森系）、场景（海景、游艇、水下、教堂）、商家简称（xx婚纱摄影旗舰店...）、
        优惠信息（拍一送一、底片全送、团队升级...）、服装套系（十服十造等等）、精修（精修50张等等）等信息；`,
        ex: [
          '【海南】韩式公主风+双内景+精修50张',
          '【小清新】文艺青年喜爱的电影剧情风格 外景+内景 精修140张',
          '【青岛】丽江雪山拉市海骑马划船浪漫旅拍'
        ]
      }
    ]
  },
  '7': {
    keyword: `建议输入利益点(赠品) 、模式(单机位、双机位、航拍、摄影摄像套餐) 、
      类型(婚礼跟拍、旅拍、领证跟拍、写真、证件照) 、风格(个性创意、小清新、欧美纪实) 、
      营销词(超值搭配、婚礼必备），每个套餐标题要在24字之内，建议体现四项关键词；`,
    ex: [
      '首席双机位婚礼摄影原片1000精修100',
      '【组合套餐】总监摄影双机+摄像三机位全程跟拍',
      '自由旅拍婚照3服3造3场景精修40'
    ],
    long: '582px'
  },
  '8': {
    keyword: `建议输入利益点(赠品) 、模式(单机位、双机位、航拍、摄影摄像套督) 、
      类型(微电影、领证跟拍、婚礼短片、婚礼MV、快剪14K) 、风格(个性创意、沙画、动画、电影风格) 、
      营销词(大师级别、明星定制类似这种)等，每个套餐标题要在24字之内，建议体现四项关键词；`,
    ex: [
      '4机位婚礼电影看看吴京和谢楠的婚礼怎么拍',
      'VIP高端定制总监档婚礼电影唯美户外婚礼摄像',
      '大师级三机位＋大摇臂＋婚礼现场快剪'
    ],
    long: '582px'
  },
  '9': {
    keyword: `建议输入利益点(赠品) 、化妆师级别(总监、首席、专家、资深) 、跟妆时间(全天跟妆、半天跟妆、早妆、晚妆)、妆容风格(日韩、复古、中式、森系) 、
      营销词(女神必选、榜单热销类似这种)等，每个套餐标题要在24字之内，建议体现出四项关键词;`,
    ex: [
      '资深档全程跟妆2造型唯美简约妆容 送亲友妆',
      '总监档森系唯美婚照 送化妆六件套+亲友妆',
      '【女神必选】总监档全天跟妆+亲友妆'
    ],
    long: '558px'
  },
  '11': {
    keyword:
      '建议输入利益点(赠品) 、模式(草坪婚礼、晚宴、其他) 、人员配置、风格（大气、稳重、幽默、浪漫、中式)、营销词(人气好评、名嘴主持)，每个套餐标题要在24字之内，建议体现四项关键词；',
    ex: [
      '资深主持+专业流程策划+督导+音乐执行',
      '【人气好评】资深讲师级主持 多风格带DJ督导',
      '学院派司仪 简约轻松风格主持+配乐+DJ'
    ],
    long: '520px'
  },
  '12': second_category_id => {
    const female = second_category_id == 6
    return {
      keyword: `商家名/款式/品牌/套件${
        female ? '/婚纱用途' : ''
      }/材质/赠送内容/营销词等，建议12-24个字，如下`,
      ex: female
        ? [
            '超性感鱼尾主纱 高个新娘必选',
            '【超值租赁】4件套租赁 全款送灰姑娘水晶鞋',
            '梦幻公主系列定制婚纱+礼服+男士西服3件套'
          ]
        : [
            '上门量身定制 纯羊毛修身商务西服',
            '【高贵气质】绅士精品西服套装 品质推荐',
            '【送衬衣领结】百搭款西服定制套装'
          ],
      long: '520px',
      children: [
        {
          id: 0,
          keyword: `建议输入营销点（XX年新款、XX明星同款、赠XX,超值租赁……）风格（中式、宫廷、时尚、甜美、复古、简约、优雅……）
        款式（长拖尾、小拖尾、鱼尾、秀禾服、龙凤褂、长袖、一字肩…）面料（网纱、蕾丝、绸缎……）效果（显瘦、显高、遮肉……）商家简称最好在四个字以内`,
          ex: [
            '18年秀款奢华复古设计拖尾纱',
            '超性感鱼尾主纱 高个新娘必选',
            '【超值租赁】简约梦幻一字肩拖尾纱 全款赠水晶鞋'
          ],
          notice:
            '单品标题的设置会影响到单品的点击，切勿出现单品标题与实际内容不符的情况。'
        }
      ]
    }
  }
}

const STYLE_LIST = [
  {
    name: '1套',
    value: '1套'
  },
  {
    name: '2套',
    value: '2套'
  },
  {
    name: '3套',
    value: '3套'
  },
  {
    name: '4套',
    value: '4套'
  },
  {
    name: '5套',
    value: '5套'
  },
  {
    name: '6套',
    value: '6套'
  },
  {
    name: '7套',
    value: '7套'
  },
  {
    name: '8套',
    value: '8套'
  },
  {
    name: '8套以上',
    value: '8套以上'
  },
  {
    name: '不限',
    value: '不限'
  },
  {
    name: '其他',
    value: '其他'
  }
]

const VALIDATE_FIELDS = [
  'title',
  'actual_price',
  'cover_path',
  'vertical_image',
  'clothing'
]

export default {
  user_tips: USER_TIP,
  style_list: STYLE_LIST,
  volidate_fields: VALIDATE_FIELDS
}
